import { FormBuilderControlType } from "@common/formbuilder/FormBuilderControlType";
import { IColumnOptions } from "../../framework/interfaces/IEntity";
import { ViewType, FieldType } from "../../framework/core/Enums";


export module FormBuilderControlListHelper {



  export function getListColumn(field: string, display: string, controlType: ViewType = ViewType.String, nestedValue: string = "", dbField: string = ""): IColumnOptions {
    if (!nestedValue || nestedValue == '')
      nestedValue = field;
    if (dbField == '')
      dbField = nestedValue.replace(".", "_");

    if (!controlType || controlType == null)
      controlType = ViewType.String;
    return {
      "field": nestedValue, "dbField": dbField, "name": display, "fieldType": 0, "readOnly": true, "filterMatchMode": "contains",
      "formBuilderControl": { "controlType": { "viewType": controlType }, "displayName": display, "bindingValue": field, "field": dbField }
    }
  }
}
